'use strict'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.$ = window.jQuery = require('jquery')
require('jquery.easing')

/* MDL stuff
 * --------------------------------------------------------------- */
import MdlUpload from './mdl/upload';
// import MdlPrompt from './mdl/prompt';
// import MdlNfc from './mdl/nfc';

import { alertOnWindow } from './app/alerts'
import materialize from './app/material'
import bind from './app/bind'
import btnConfirm from './app/btn_submit'
import userContactsSearch from './app/users/contacts'

jQuery(document).ready(function () {
  alertOnWindow()
  materialize()
  MdlUpload()

  bind()
  btnConfirm()
  userContactsSearch()
})


// WEBPACK FOOTER //
// ./resources/assets/js/app.js